import { render, staticRenderFns } from "./TokenTransactionsList.vue?vue&type=template&id=165ab086&"
import script from "./TokenTransactionsList.vue?vue&type=script&lang=js&"
export * from "./TokenTransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./TokenTransactionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports